import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoGoLiveParentGuideInfoQueryVariables = Types.Exact<{
  goGoLiveParentGuideId: Types.Scalars['Int']['input'];
}>;


export type GoGoLiveParentGuideInfoQuery = { __typename?: 'Query', goGoLiveParentGuideInfo: Array<{ __typename?: 'GoGoLiveParentGuideDetailInfo', goGoLiveParentGuideId: number, yearAndMonth: string, levelId: string, levelName: string, lessonTitle: string, previewVideoVimeoId: string, previewVideoCoverImageFileName: string, introduction: string, learningGoals: Array<string>, languagePoint: string, bookPage: string, showAndTell: string, printableSheet: string, sessions: Array<{ __typename?: 'GoGoLiveSessionInfo', sessionId: number, sessionName?: string | null }>, songList: Array<{ __typename?: 'GoGoLiveParentGuideSongInfo', discCode: string, eTabCode: string, songs: Array<{ __typename?: 'GoGoLiveSongInfo', songId: number, songName?: string | null }> }>, wordList: Array<{ __typename?: 'TalkAlongCardInfo', talkAlongCardId: number, cardNumber?: string | null, word?: string | null }>, toys: Array<{ __typename?: 'GoGoLiveToyInfo', toyId: number, toyName?: string | null, toyImageFile?: string | null }> }> };


export const GoGoLiveParentGuideInfoDocument = gql`
    query GoGoLiveParentGuideInfo($goGoLiveParentGuideId: Int!) {
  goGoLiveParentGuideInfo(goGoLiveParentGuideId: $goGoLiveParentGuideId) {
    goGoLiveParentGuideId
    yearAndMonth
    levelId
    levelName
    lessonTitle
    previewVideoVimeoId
    previewVideoCoverImageFileName @wf_blobPublicSignature(name: "GOGOLIVE_PARENT_GUIDE_IMAGES_COVER_SIGNATURE")
    introduction
    learningGoals
    languagePoint
    bookPage
    showAndTell
    printableSheet @wf_blobPublicSignature(name: "GOGOLIVE_PARENT_GUIDE_PDFS_SIGNATURE")
    sessions {
      sessionId
      sessionName
    }
    songList {
      discCode
      eTabCode
      songs {
        songId
        songName
      }
    }
    wordList {
      talkAlongCardId
      cardNumber
      word
    }
    toys {
      toyId
      toyName
      toyImageFile @wf_blobPublicSignature(name: "GOGOLIVE_PARENT_GUIDE_IMAGES_TOY_SIGNATURE")
    }
  }
}
    `;

/**
 * __useGoGoLiveParentGuideInfoQuery__
 *
 * To run a query within a React component, call `useGoGoLiveParentGuideInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoGoLiveParentGuideInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoGoLiveParentGuideInfoQuery({
 *   variables: {
 *      goGoLiveParentGuideId: // value for 'goGoLiveParentGuideId'
 *   },
 * });
 */
export function useGoGoLiveParentGuideInfoQuery(baseOptions: Apollo.QueryHookOptions<GoGoLiveParentGuideInfoQuery, GoGoLiveParentGuideInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoGoLiveParentGuideInfoQuery, GoGoLiveParentGuideInfoQueryVariables>(GoGoLiveParentGuideInfoDocument, options);
      }
export function useGoGoLiveParentGuideInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoGoLiveParentGuideInfoQuery, GoGoLiveParentGuideInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoGoLiveParentGuideInfoQuery, GoGoLiveParentGuideInfoQueryVariables>(GoGoLiveParentGuideInfoDocument, options);
        }
export type GoGoLiveParentGuideInfoQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideInfoQuery>;
export type GoGoLiveParentGuideInfoLazyQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideInfoLazyQuery>;
export type GoGoLiveParentGuideInfoQueryResult = Apollo.QueryResult<GoGoLiveParentGuideInfoQuery, GoGoLiveParentGuideInfoQueryVariables>;